import type { Post, Category, Author, Tag } from '@/payload-types'

/**
 * Risolutori di relazioni Payload per il rendering. Le relazioni con depth>0 sono
 * oggetti popolati; con depth 0 (o non popolate) restano id grezzi. Questi helper
 * centralizzano il narrowing «oggetto vs id» finora duplicato in più componenti.
 */
const isPopulated = <T>(v: unknown): v is T => !!v && typeof v === 'object'

/** Prima categoria popolata del post (o null). */
export const firstCategory = (post: Post): Category | null => {
  const c = Array.isArray(post.categories) ? post.categories[0] : undefined
  return isPopulated<Category>(c) ? c : null
}

/** Categoria da mostrare: `seo.primaryCategory` se presente, altrimenti la prima. */
export const primaryCategory = (post: Post): Category | null => {
  const pc = post.seo?.primaryCategory
  return isPopulated<Category>(pc) ? pc : firstCategory(post)
}

/** Autore popolato del post (o null). */
export const postAuthor = (post: Post): Author | null =>
  isPopulated<Author>(post.author) ? post.author : null

/** Tag popolati del post (scarta gli id grezzi). */
export const resolvedTags = (post: Post): Tag[] =>
  Array.isArray(post.tags) ? post.tags.filter((t): t is Tag => isPopulated<Tag>(t)) : []
